<template>
  <div class="modal" v-if="visible" :style="fixedStyle">
    <div class="modal-content" v-click-outside="onClickOutside" >
      <span class="close" @click="close">&times;</span>
      <div class="login-modal">
        <div class="login-modal__inner">
          <div class="login-modal__tabs" :class="{login: isLoginTab, signup: !isLoginTab}"></div>
          <div class="login-modal__content">
            <div class="login-modal__header">
              <a
                class="header__tab"
                @click.prevent="loginTab"
                :class="{active: isLoginTab}"
                href
              >ログイン</a>
              <span>/</span>
              <a
                class="header__tab"
                @click.prevent="registerTab"
                :class="{active: !isLoginTab}"
                href
              >新規登録</a>
            </div>
            <slot v-if="isLoginTab">
              <ul class="error" v-if="errors.length > 0">
                <li v-for="error in errors" :key="error">{{ error }}</li>
              </ul>
              <div class="login-modal__title">ログインしてください</div>
              <div class="login-modal__subtitle">素敵なお花を見つけましょう</div>
              <div class="form-control">
                <label>Eメール</label>
                <input class="input" v-model="email" id="email"/>
              </div>
              <div class="form-control">
                <label>パスワード</label>
                <div class="input-group-prepend">
                  <input class="input" :type="passwordType" v-model="password" id="password" />
                  <span class="input-show-password" @click="showPassword()">
                    <i v-if="passwordType == 'password'" class="fa fa-regular fa-eye-slash"></i>
                    <i v-else class="fa fa-regular fa-eye"></i>
                  </span>
                </div>
              </div>
              <div class="login-modal__addon">
                <label class="checkbox">
                  パスワードを保存
                  <input type="checkbox" v-model="rememberMe" />
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="cart__summary__buttons right__content">
                <button class="button" type="button" @click="logIn" id="logInBtn">ログインする</button>
                <div class="ores">または</div>
                <button class="button invert" type="button" @click="registerTab">アカウント作成</button>
              </div>
              <div class="right__content">
                <a href="/users/password/new">パスワードを忘れた方</a>
                <a href="/users/confirmation/new">確認メールが届かなかった場合はこちら</a>
              </div>
            </slot>

            <!-- SIGN UP -->
            <slot v-if="!isLoginTab">
              <div class="login-modal__title">アカウント登録</div>
              <div class="login-modal__subtitle">メールアドレスでアカウントを登録する</div>
              <div class="login-modal__form">
                <div class="form-control">
                  <label>Email</label>
                  <div class="input__section">
                    <input class="input" v-model="email" />
                    <template v-if="errors.email">
                      <span class="error" v-for="error in errors.email" :key="error">{{ error }}</span>
                    </template>
                  </div>
                </div>
                <div class="form-control">
                  <label>パスワード</label>
                  <div class="input__section">
                    <input class="input" type="password" v-model="password" />
                    <template v-if="errors.password">
                      <span class="error" v-for="error in errors.password" :key="error">{{ error }}</span>
                    </template>
                  </div>
                </div>
                <div class="form-control">
                  <label>
                    パスワード
                    <br />(確認用)
                  </label>
                  <div class="input__section">
                    <input class="input" type="password" v-model="passwordConfirmation" />
                    <template v-if="errors.password_confirmation">
                      <span
                        class="error"
                        v-for="error in errors.password_confirmation"
                        :key="error"
                      >{{ error }}</span>
                    </template>
                  </div>
                </div>
                <div class="form-control">
                  <label>お名前</label>
                  <div class="input__section">
                    <input class="input" type="text" v-model="name" />
                    <template v-if="errors.name">
                      <span class="error" v-for="error in errors.name" :key="error">{{ error }}</span>
                    </template>
                  </div>
                </div>
                <div class="form-control">
                  <label>性別</label>
                  <div class="input__section">
                    <div class="flex max-width">
                      <div class="gender">
                        <input type="radio" id="male" value="male" name="gender" v-model="gender" />
                        <label for="male" class="gender-label male">男性</label>
                      </div>
                      <div class="gender">
                        <input
                          type="radio"
                          id="female"
                          value="female"
                          name="gender"
                          v-model="gender"
                        />
                        <label for="female" class="gender-label female">女性</label>
                      </div>
                    </div>
                    <template v-if="errors.gender">
                      <span class="error" v-for="error in errors.gender" :key="error">{{ error }}</span>
                    </template>
                  </div>
                </div>
                <div class="form-control mb-20">
                  <label>利用者</label>
                  <div class="input__section">
                    <div class="flex max-width">
                      <label class="radio">
                        <input
                          type="radio"
                          id="corporation"
                          value="corporation"
                          name="user_type"
                          v-model="userType"
                        />
                        <span class="checkmark"></span>
                        <label for="corporation" class="user__type">法人</label>
                      </label>
                      <label class="radio">
                        <input
                          type="radio"
                          id="personal"
                          value="personal"
                          name="user_type"
                          v-model="userType"
                        />
                        <span class="checkmark"></span>
                        <label for="personal" class="user__type">個人</label>
                      </label>
                    </div>
                    <template v-if="errors.user_type">
                      <span class="error" v-for="error in errors.user_type" :key="error">{{ error }}</span>
                    </template>
                  </div>
                </div>
                <div class="form-control">
                  <label>きっかけ</label>
                  <v-select :options="reasonOptions" label="text" v-model="registReason"></v-select>
                </div>
                <div class="form-control flat">
                  <label>利用規約</label>
                  <div class="input__section">
                    <Contract v-model="agreement"></Contract>
                    <div v-if="errors.agreement">
                      <span class="error" v-for="error in errors.agreement" :key="error">{{ error }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cart__summary__buttons right__content">
                <button class="button" type="button" @click="signUp">登録する</button>
                <div class="ores">または</div>
                <button class="button invert" type="button" @click="loginTab">ログインする</button>
              </div>
              <div class="right__content">
                <a href="/users/password/new">パスワードを忘れた方</a>
                <a href="/users/confirmation/new">確認メールが届かなかった場合はこちら</a>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
import vClickOutside from "v-click-outside";
import Contract from "./Contract";

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: { Contract },
  props: {
    checkVisible: {
      type: Boolean,
      required: false,
      default: false
    },
    isCheckLoginTab: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  created: function() {
    this.checkVisibleModalParams()
  },
  data: function() {
    return {
      visible: false,
      email: "",
      password: "",
      passwordConfirmation: "",
      rememberMe: false,
      isLoginTab: true,
      redirectUrl: null,
      agreement: false,
      name: "",
      gender: "",
      userType: "",
      reasonOptions: [
        { text: "イベントで知った", value: "event" },
        { text: "営業訪問", value: "sales" },
        { text: "DMが来た", value: "dm" },
        { text: "電話が来た", value: "tel" },
        { text: "広告を見た", value: "ad" },
        { text: "紹介を受けた", value: "introduced" },
        { text: "ネット検索", value: "net_search" },
        { text: "その他", value: "others" }
      ],
      registReason: {},
      errors: {},
      fixedStyle: {},
      passwordType: "password",
    };
  },
  methods: {
    checkVisibleModalParams: function() {
      this.visible = this.checkVisible;
      this.isLoginTab = this.isCheckLoginTab;
    },
    onClickOutside: function(event, el) {
      if (el.className !== "modal") {
        this.close();
      }
    },
    open: function(options = {}) {
      this.visible = true;
      if (options.redirectUrl) {
        this.redirectUrl = options.redirectUrl;
      }
      this.fixedStyle = {
        position: "fixed !important"
      };
    },
    close: function() {
      this.visible = false;
      document.body.className = "";
    },
    registerTab: function() {
      this.isLoginTab = false;
    },
    loginTab: function() {
      this.isLoginTab = true;
    },
    logIn: function() {
      let self = this;

      this.$axios
        .post("/users/sign_in.json", {
          user: {
            email: this.email,
            password: this.password,
            rememberMe: this.rememberMe
          }
        })
        .then(function(res) {
          self.$toasted.success("ログインしました。", {
            duration: 1000,
            theme: "bubble",
            onComplete: () => {
              const redirectUrl = self.redirectUrl || "/";
              window.location.replace(redirectUrl);
            }
          });
        })
        .catch(function(err) {
          self.$toasted.error(
            "ログイン失敗しました。再度ご確認をお願いします。",
            {
              duration: 1000,
              theme: "bubble"
            }
          );

          self.errors = err.response.data;
        });
    },
    signUp: async function() {
      try {
        this.$root.$refs.Loading.show();

        const response = await this.$axios.post("/users.json", {
          user: {
            email: this.email,
            password: this.password,
            password_confirmation: this.passwordConfirmation,
            name: this.name,
            gender: this.gender,
            user_type: this.userType,
            regist_reason: this.registReason.value || "no_reason",
            agreement: this.agreement
          }
        });

        this.$toasted.success(
          "ログインするためには、アカウントを有効化してください。",
          {
            duration: 1000,
            theme: "bubble",
            onComplete: () => {
              this.close();
            }
          }
        );

        this.errors = {};
      } catch (error) {
        this.$toasted.error(
          "登録が失敗しました。エラー内容をご確認お願いします。",
          {
            duration: 1000,
            theme: "bubble"
          }
        );
        this.errors = error.response.data;
      } finally {
        this.$root.$refs.Loading.hide();
      }
    },

    showPassword() {
      if (this.passwordType == "password") {
        this.passwordType = "text";
      } else {
        this.passwordType = "password";
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/base/mixins";

.modal {
  z-index: 9999;
}

.modal-content {
  width: 100%;
}

.right__content {
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  .button {
    width: 100% !important;
  }
}

.ores {
  position: relative;
  font-size: 12px;
  font-size: 1.2rem;
  color: #d5d7da;
  text-align: center;
  padding: 16px 0;
  width: 100%;

  &::before {
    content: "";
    left: 0;
    display: block;
    position: absolute;
    top: 50%;
    width: 25%;
    height: 1px;
    background: #d5d7da;
    transform: translate3d(0, -50%, 0);
  }

  &::after {
    content: "";
    right: 0;
    display: block;
    position: absolute;
    top: 50%;
    width: 25%;
    height: 1px;
    background: #d5d7da;
    transform: translate3d(0, -50%, 0);
  }
}

.cart__summary__buttons {
  margin-top: 0 !important;
  margin-bottom: 15px;
  .invert {
    margin-top: 0;
  }
}

.login-modal {
  display: flex;
  flex-wrap: wrap;
  text-align: left;
  overflow-y: auto;
  width: 100%;

  &__inner {
    display: flex;
    width: 100%;
  }

  @include scrollbar;

  &__tabs {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    width: 370px;
    min-width: 370px;
    background-size: cover;
    background-repeat: no-repeat;
    padding: 67px 67px 155px;
    position: relative;

    &.login {
      background-image: url("../../images/login.png");
    }

    &.signup {
      background-image: url("../../images/signup-bg.jpg");
    }

    &::after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0.46;
      z-index: 1;
    }
  }

  &__tab-item {
    opacity: 0.46;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 14px;
    color: #ffffff;
    position: relative;
    z-index: 2;

    &.active {
      font-size: 60px;
      opacity: 1;
    }
  }

  &__content {
    flex-grow: 1;
    flex-shrink: 1;
    width: calc(100% - 370px);
    padding: 20px 72px 75px 50px;

    .form-control {
      margin-bottom: 17px;

      > label {
        min-width: 130px;
      }

      .input {
        width: 100%;
        padding: 12px 15px;
      }

      .input-group-prepend {
        width: 100%;
        position: relative;

        input {
          width: 90%;
        }

        .input-show-password {
          position: absolute;
          right: 1px;
          top: 50%;
          transform: translateY(-50%);
          cursor: pointer;
          background: #f5f5f5;
          width: 10%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #e5e5e5;

          i {
            color: #73c3ab;
          }
        }
      }
    }

    .button {
      width: 243px;
    }
  }

  &__header {
    font-size: 35px;
    color: #b2b2b2;
    margin-bottom: 10px;
    .header__tab {
      font-size: 28px;
      color: #b2b2b2;
      &.active {
        font-size: 40px;
        color: #73c3ab;
      }
    }
  }

  &__title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 14px;
    color: #000000;
  }

  &__subtitle {
    font-size: 18px;
    color: #373737;
    margin-bottom: 20px;
  }

  &__addon {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    > a {
      width: 100%;
      flex-grow: 1;
      flex-shrink: 1;
      white-space: nowrap;
      text-align: right;
    }
  }

  .terms {
    display: block;
    font-size: 18px;
    line-height: 18px;
    border: 1px solid #e5e5e5;
    width: 100%;
    margin-bottom: 35px;

    &:focus {
      border-color: #73c3ab;
    }

    &__content {
      padding: 15px 20px;
      border-bottom: 15px solid #fff;
      height: 110px;
      overflow: auto;
      font-size: 12px;
      font-weight: 400;
      color: #949494;

      @include scrollbar;
    }

    &__footer {
      display: flex;
      position: relative;
      border-top: 1px solid #e5e5e5;
      padding: 5px 20px;

      .checkbox {
        width: auto;
        word-break: unset;
        margin-bottom: 0;
      }
    }
  }

  &__form {
    max-height: 500px;
    overflow-y: auto;
  }
}

@media only screen and (max-width: 1200px) {
  .modal-content {
    transform: scale(0.8);
  }
}

@media only screen and (max-width: 992px) {
  .modal {
    &-content {
      display: block;
      overflow: hidden;
      transform: scale(1);
      width: 100%;
      max-width: 720px;

      > .close {
        z-index: 1;
        top: 8px;
        right: 15px;
      }
    }
  }

  .login-modal {
    width: 100%;
    height: 100%;
    overflow: auto;

    &__inner {
      display: block;
      width: 100%;
    }

    &__header {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      background: white;
      padding: 21px 20px;
      margin: 0;
      font-size: 16px;

      .header__tab {
        font-size: 16px;

        &.active {
          font-size: 16px;
        }
      }
    }

    &__tabs {
      margin-top: 60px;
      padding: 0;
      height: 175px;
      width: 100%;
      background-position: center;
      background-size: cover;
    }

    &__content {
      width: 100%;
      padding: 22px 15px;

      .form-control {
        flex-wrap: wrap;

        > label {
          font-size: 14px;
          margin-bottom: 5px;
          width: 100%;
        }

        > .input {
          width: 100%;
        }
      }
    }

    &__title {
      font-size: 16px;
    }

    &__subtitle {
      font-size: 14px;
    }

    &__addon {
      font-size: 12px;
    }

    &__button {
      > .button {
        margin: auto;
        display: block;
        font-size: 14px;
        padding: 12px;
        width: 164px;
      }
    }
  }

  .terms {
    width: 100%;
  }
}

@media only screen and (max-width: 768px) {
  .modal {
    &-content {
      border-radius: 0;
      height: 100%;
      max-width: 100%;
      border-radius: 0;
    }
  }
}
</style>
